import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AssetModalContentHeaderProps = ComponentProps<'header'>;

export const AssetModalContentHeader = memo(({ className, ...restOfProps }: AssetModalContentHeaderProps) => {
  return <header className={cn('flex size-full shrink-0 items-center justify-center', className)} {...restOfProps} />;
});

AssetModalContentHeader.displayName = 'AssetModalContentHeader';
